import { Palette } from '@core/config/constants';

/** Configuracion especifica del minijuego de aventura (atrapar estrellas). */
export const AdventureConfig = {
  key: 'AdventureScene',
  title: 'Aventura Estelar',
  description: 'Atrapa las estrellas y esquiva las nubes de tormenta.',
  icon: '🏃',
  color: Palette.secondary,

  /** Vidas con las que arranca el jugador. */
  startingLives: 3,
  /** Cada cuanto cae un objeto nuevo (ms). Baja con el tiempo para subir dificultad. */
  initialSpawnIntervalMs: 900,
  minSpawnIntervalMs: 380,
  /** Cuanto se acelera el ritmo de aparicion por cada objeto bueno atrapado (ms). */
  spawnSpeedupPerHitMs: 8,
  /** Velocidad de caida de los objetos (px por segundo). */
  fallSpeedMin: 220,
  fallSpeedMax: 420,
  /** Probabilidad (0-1) de que un objeto que cae sea una nube (peligro). */
  hazardChance: 0.28,
  /** Puntos por atrapar una estrella. */
  pointsPerStar: 15,
  /** Velocidad horizontal del jugador con teclado (px por segundo). */
  playerSpeed: 720,
  /** Radio aproximado de colision del jugador y de los objetos. */
  collisionRadius: 52,
  /** Monedas otorgadas al finalizar por cada 100 puntos. */
  coinsPer100Points: 1,
} as const;
